import { Component, OnInit } from '@angular/core';
import { PaymentService, ProductDisplay } from 'src/app/payment/payment.service';
import { UtilitieService } from 'src/app/services/utils/utilities.service';

@Component({
  selector: 'sub-pricing',
  templateUrl: './sub-pricing.component.html',
  styleUrls: ['./sub-pricing.component.css']
})
export class SubPricingComponent implements OnInit {

  billingToggle: boolean = true;

  activeFaqIndex: number | null = null;
  products: ProductDisplay[];
  selectedProduct: ProductDisplay;



  constructor(private paymentService: PaymentService, private utilService: UtilitieService) { }

  toggleFaq(index: number): void {
    this.activeFaqIndex = this.activeFaqIndex === index ? null : index;
  }

  async ngOnInit(): Promise<void> {
    this.utilService.updateLoading(true);

    this.products = await this.paymentService.getProducts();
    this.selectedProduct = this.products[0];
    this.utilService.updateLoading(false);
  }

}
